module.exports = new __parcel__URL__("global-opt-in-default-image-banner.cf053e66.svg").toString();